import { highlight } from '@toggle/helpers';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '~/react-query-hooks/themes/useThemeOverview';
import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

import { Theme } from '../../utils';
import styles from './ListThemeItem.module.scss';

export interface ListThemeItemProps {
  theme: Theme;
  onFocus?: (name: string) => void;
  highlighted?: string;
  isFocused: boolean;
}

export const ListThemeItem = ({
  theme,
  onFocus,
  highlighted,
  isFocused,
}: ListThemeItemProps) => {
  const { t } = useTranslation('widget');
  const { data } = useTheme({
    themeId: theme.id,
  });

  const logoUrl = data?.logo_url;

  const themeName = highlighted
    ? highlight(theme.name, highlighted)
    : theme.name;

  return (
    <button
      className={clsx(styles.listThemeItemRoot, {
        [styles.isFocused]: isFocused,
      })}
      data-testid={`list-theme-item-${theme.id}`}
      onFocus={() => onFocus?.(theme.name)}
    >
      <ThemeLogoIcon
        name={theme.name}
        logo_url={logoUrl}
        isCondensed={false}
        fallbackIcon={
          <div className={styles.logoWrapper}>{theme.name.charAt(0)}</div>
        }
      />
      <div className={styles.details}>
        <span className={styles.title}>{themeName}</span>
        <span className={styles.subtitle}>
          {t('widget:themeOverview.investmentTheme')}
        </span>
      </div>
    </button>
  );
};
